import _toConsumableArray from "/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.17.8-4817ae02f7-68d195c163.zip/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.17.8-4817ae02f7-68d195c163.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.17.8-4817ae02f7-68d195c163.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect } from 'react';
var TokenType;

(function (TokenType) {
  TokenType[TokenType["L_CURLY"] = 0] = "L_CURLY";
  TokenType[TokenType["R_CURLY"] = 1] = "R_CURLY";
  TokenType[TokenType["L_BRACKET"] = 2] = "L_BRACKET";
  TokenType[TokenType["R_BRACKET"] = 3] = "R_BRACKET";
  TokenType[TokenType["COMMA"] = 4] = "COMMA";
  TokenType[TokenType["COLON"] = 5] = "COLON";
  TokenType[TokenType["PIPE"] = 6] = "PIPE";
  TokenType[TokenType["NL"] = 7] = "NL";
  TokenType[TokenType["SPACE"] = 8] = "SPACE";
})(TokenType || (TokenType = {}));

function prettify(text) {
  return text.split(/\n/g).map(function (line, index) {
    return React.createElement("div", {
      key: index,
      style: {
        marginTop: index > 0 ? "1rem" : 0
      }
    }, line);
  });
}

function JsonSchemaAnnotation(_ref) {
  var style = _ref.style,
      children = _ref.children;
  return React.createElement("div", {
    className: "rjd-annotation",
    style: _objectSpread({
      marginBottom: "1rem",
      borderRadius: "var(--ifm-pre-background, 0.25rem)",
      padding: "1rem",
      whiteSpace: "normal"
    }, style)
  }, children);
}

function getCurrentHash() {
  return window.location.hash.slice(1);
}

function JsonDoc(_ref2) {
  var theme = _ref2.theme,
      _ref2$descriptionRend = _ref2.descriptionRenderer,
      descriptionRenderer = _ref2$descriptionRend === void 0 ? {
    render: prettify
  } : _ref2$descriptionRend,
      extraTheme = _ref2.extraTheme,
      _ref2$linkComponent = _ref2.linkComponent,
      Link = _ref2$linkComponent === void 0 ? "a" : _ref2$linkComponent,
      _ref2$skipFirstIndent = _ref2.skipFirstIndent,
      skipFirstIndent = _ref2$skipFirstIndent === void 0 ? true : _ref2$skipFirstIndent,
      data = _ref2.data;
  var styleByType = new Map();

  var _iterator = _createForOfIteratorHelper(theme.styles),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          style = _step$value.style,
          types = _step$value.types;

      var _iterator3 = _createForOfIteratorHelper(types),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var type = _step3.value;
          styleByType.set(type, style);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeId = _useState2[0],
      setActiveId = _useState2[1];

  useEffect(function () {
    setActiveId(getCurrentHash());
  });
  var sections = [{
    id: null,
    header: null,
    closed: false,
    lines: [{
      indent: 0,
      tokens: []
    }]
  }];
  var idSegments = [];
  var indentSize = 24;
  var indentCount = 0;
  var isInlineContext = [false];
  var onTokenPush = null;

  var indentedBlock = function indentedBlock(lTok, rTok, foldStyle, fn) {
    var isEmpty = true;
    pushToken(lTok);

    onTokenPush = function onTokenPush(tok) {
      isEmpty = false;
      var effectiveFoldStyle = typeof foldStyle !== "undefined" ? foldStyle : tok !== TokenType.L_BRACKET && tok !== TokenType.L_CURLY;

      if (effectiveFoldStyle) {
        pushToken(TokenType.NL);
        indentCount += 1;
        isInlineContext.push(false);
      } else {
        isInlineContext.push(true);
      }
    };

    fn();
    onTokenPush = null;

    if (!isEmpty) {
      var hasIndent = !isInlineContext.pop();

      if (hasIndent) {
        indentCount -= 1;
      }
    }

    pushToken(rTok);
  };

  var startNewSection = function startNewSection() {
    var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    sections.push({
      id: header ? idSegments.join(".") : null,
      header: header,
      closed: false,
      lines: [{
        indent: 0,
        tokens: []
      }]
    });
  };

  var closeSection = function closeSection() {
    var section = sections[sections.length - 1];

    if (section.header) {
      section.closed = true;
    }
  };

  var getCurrentId = function getCurrentId() {
    var section = sections[sections.length - 1];
    return section.closed ? null : section.id;
  };

  var startNewLine = function startNewLine() {
    var initialSection = sections[sections.length - 1];

    if (initialSection.closed) {
      startNewSection();
      return;
    }

    var section = sections[sections.length - 1];
    section.lines.push({
      indent: 0,
      tokens: []
    });
  };

  var getIndentedLine = function getIndentedLine() {
    var initialSection = sections[sections.length - 1];
    if (initialSection.closed) startNewSection();
    var section = sections[sections.length - 1];
    var line = section.lines[section.lines.length - 1];
    if (line.tokens.length === 0) line.indent = indentCount;
    return line.tokens;
  };

  var triggerPushFn = function triggerPushFn(token) {
    var onTokenPushFn = onTokenPush;
    onTokenPush = null;
    onTokenPushFn === null || onTokenPushFn === void 0 ? void 0 : onTokenPushFn(token);
  };

  var pushReference = function pushReference(node) {
    triggerPushFn();

    var style = _objectSpread(_objectSpread({}, styleByType.get("attr-name")), extraTheme.identifier);

    var line = getIndentedLine();
    var propertyName = node.$ref.replace("#/properties/", "");
    data.properties[propertyName];
    line.push(React.createElement(React.Fragment, {
      key: line.length
    }, React.createElement("span", {
      style: {
        color: "#ffffff"
      }
    }, "See"), " ", React.createElement(Link, {
      href: "#".concat(propertyName),
      style: style
    }, propertyName)));
  };

  var pushIdentifier = function pushIdentifier(name) {
    triggerPushFn();
    var id = getCurrentId();

    var style = _objectSpread(_objectSpread({}, styleByType.get("attr-name")), extraTheme.identifier);

    var line = getIndentedLine();
    line.push(React.createElement(Link, {
      key: line.length,
      href: "#".concat(id)
    }, React.createElement("span", {
      style: style
    }, name)));
  };

  var pushString = function pushString(str) {
    triggerPushFn();
    var style = styleByType.get("string");
    var line = getIndentedLine();
    line.push(React.createElement("span", {
      key: line.length,
      style: style
    }, JSON.stringify(str)));
  };

  var pushNull = function pushNull(val) {
    triggerPushFn();
    var style = styleByType.get("null");
    var line = getIndentedLine();
    line.push(React.createElement("span", {
      key: line.length,
      style: style
    }, JSON.stringify(val)));
  };

  var pushNumber = function pushNumber(val) {
    triggerPushFn();
    var style = styleByType.get("number");
    var line = getIndentedLine();
    line.push(React.createElement("span", {
      key: line.length,
      style: style
    }, JSON.stringify(val)));
  };

  var pushBoolean = function pushBoolean(val) {
    triggerPushFn();
    var style = styleByType.get("keyword");
    var line = getIndentedLine();
    line.push(React.createElement("span", {
      key: line.length,
      style: style
    }, JSON.stringify(val)));
  };

  var pushSyntaxToken = function pushSyntaxToken(raw) {
    triggerPushFn();
    var style = styleByType.get("punctuation");
    var line = getIndentedLine();
    line.push(React.createElement("span", {
      key: line.length,
      style: style
    }, raw));
  };

  var pushToken = function pushToken(token) {
    triggerPushFn(token);

    switch (token) {
      case TokenType.L_CURLY:
        {
          pushSyntaxToken("{");
        }
        break;

      case TokenType.R_CURLY:
        {
          pushSyntaxToken("}");
        }
        break;

      case TokenType.L_BRACKET:
        {
          pushSyntaxToken("[");
        }
        break;

      case TokenType.R_BRACKET:
        {
          pushSyntaxToken("]");
        }
        break;

      case TokenType.COMMA:
        {
          pushSyntaxToken(",");
        }
        break;

      case TokenType.COLON:
        {
          pushSyntaxToken(":");
        }
        break;

      case TokenType.PIPE:
        {
          pushSyntaxToken("|");
        }
        break;

      case TokenType.SPACE:
        {
          getIndentedLine().push(" ");
        }
        break;

      case TokenType.NL:
        {
          startNewLine();
        }
        break;

      default:
        {
          throw new Error("Unsupported token type ".concat(token));
        }
    }
  };

  var processPattern = function processPattern(patterns, key) {
    for (var _i = 0, _Object$entries = Object.entries(patterns); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          pattern = _Object$entries$_i[0],
          spec = _Object$entries$_i[1];

      if (key.match(new RegExp(pattern))) {
        process(spec, {
          skipIndent: false
        });
        return;
      }
    }

    pushIdentifier("error");
  };

  var forwardExample = function forwardExample(node, example) {
    var exampleObject = node.type === "array" ? {
      exampleItems: example
    } : {
      examples: [example]
    };
    return _objectSpread(_objectSpread({}, node), exampleObject);
  };

  var getExample = function getExample(node) {
    var _a;

    var example = typeof ((_a = node.examples) === null || _a === void 0 ? void 0 : _a[0]) !== "undefined" ? node.examples[0] : node.default;
    if (typeof example === "undefined") throw new Error("Missing example (in ".concat(idSegments.join("."), ")"));
    return example;
  };

  var getDescription = function getDescription(node) {
    var _a, _b;

    var title = (_a = node.title) !== null && _a !== void 0 ? _a : "";
    var description = (_b = node.description) !== null && _b !== void 0 ? _b : "";
    return "".concat(title, "\n\n").concat(description).trim();
  };

  var pushByType = {
    null: pushNull,
    number: pushNumber,
    boolean: pushBoolean,
    string: pushString
  };

  var pushTyped = function pushTyped(value) {
    var valueType = value !== null ? typeof value : "null";
    if (!Object.prototype.hasOwnProperty.call(pushByType, valueType)) throw new Error("Unsupported type ".concat(valueType, " (in ").concat(idSegments.join("."), ")"));
    var pushFn = pushByType[valueType];
    return pushFn(value);
  };

  var process = function process(node, _ref3) {
    var skipIndent = _ref3.skipIndent;
    if (Array.isArray(node.type) && !node.type.every(function (type) {
      return Object.prototype.hasOwnProperty.call(pushByType, type);
    })) throw new Error("Unsupported type ".concat(node.type.join(", "), " (in ").concat(idSegments.join("."), ")"));
    var type = Array.isArray(node.type) ? "mixed" : node.type;

    switch (type) {
      case "null":
      case "number":
      case "boolean":
      case "string":
      case "mixed":
        {
          if (typeof node.enum === "undefined") {
            pushTyped(getExample(node));
          } else {
            pushTyped(node.enum[0]);

            for (var t = 1; t < node.enum.length; ++t) {
              pushToken(TokenType.SPACE);
              pushToken(TokenType.PIPE);
              pushToken(TokenType.SPACE);
              pushTyped(node.enum[t]);
            }
          }
        }
        break;

      case "array":
        {
          indentedBlock(TokenType.L_BRACKET, TokenType.R_BRACKET, node.foldStyle, function () {
            var _a, _b, _c;

            var exampleItems = (_c = (_b = (_a = node.exampleItems) !== null && _a !== void 0 ? _a : node._exampleItems) !== null && _b !== void 0 ? _b : node.default) !== null && _c !== void 0 ? _c : [];

            for (var _t = 0; _t < exampleItems.length; ++_t) {
              var itemNode = node.prefixItems && _t < node.prefixItems.length ? node.prefixItems[_t] : node.items;
              process(forwardExample(itemNode, exampleItems[_t]), {
                skipIndent: false
              });

              if (isInlineContext[isInlineContext.length - 1]) {
                if (_t + 1 < exampleItems.length) {
                  pushToken(TokenType.COMMA);
                  pushToken(TokenType.SPACE);
                }
              } else {
                pushToken(TokenType.COMMA);
                pushToken(TokenType.NL);
              }
            }
          });
        }
        break;

      case "object":
        {
          var injectObject = function injectObject() {
            var _a, _b;

            var exampleKeys = (_a = node.exampleKeys) !== null && _a !== void 0 ? _a : node._exampleKeys;

            if (typeof exampleKeys !== "undefined") {
              if (typeof node.patternProperties === "undefined") throw new Error("Using exampleKeys without patternProperties is not supported (in ".concat(idSegments.join("."), ")"));

              var _iterator2 = _createForOfIteratorHelper(exampleKeys),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var exampleKey = _step2.value;
                  pushIdentifier(exampleKey);
                  pushToken(TokenType.COLON);
                  pushToken(TokenType.SPACE);
                  processPattern(node.patternProperties, exampleKey);
                  pushToken(TokenType.COMMA);
                  pushToken(TokenType.NL);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else {
              var entries = Object.entries(node.properties);

              for (var _t2 = 0; _t2 < entries.length; ++_t2) {
                var _entries$_t = _slicedToArray(entries[_t2], 2),
                    propertyName = _entries$_t[0],
                    propertyNode = _entries$_t[1]; // If there's an example and it doesn't include this key, we can omit it


                if (((_b = node.examples) === null || _b === void 0 ? void 0 : _b[0]) && typeof node.examples[0][propertyName] === "undefined") continue;
                idSegments.push(propertyName);
                var description = getDescription(propertyNode);
                if (description) startNewSection(React.createElement(JsonSchemaAnnotation, {
                  style: extraTheme.annotation,
                  children: descriptionRenderer.render(description)
                }));
                pushIdentifier(propertyName);
                pushToken(TokenType.COLON);
                pushToken(TokenType.SPACE);
                var examples = node.examples ? forwardExample(propertyNode, node.examples[0][propertyName]) : {};
                process(_objectSpread(_objectSpread({}, propertyNode), examples), {
                  skipIndent: false
                });

                if (isInlineContext[isInlineContext.length - 1]) {
                  if (_t2 + 1 < entries.length) {
                    pushToken(TokenType.COMMA);
                    pushToken(TokenType.SPACE);
                  }
                } else {
                  pushToken(TokenType.COMMA);
                  pushToken(TokenType.NL);
                }

                idSegments.pop();

                if (description) {
                  closeSection();
                }
              }
            }
          };

          if (skipIndent) {
            injectObject();
          } else {
            indentedBlock(TokenType.L_CURLY, TokenType.R_CURLY, node.foldStyle, injectObject);
          }
        }
        break;

      default:
        {
          if (typeof node.$ref !== "undefined") {
            pushReference(node);
            return;
          }

          throw new Error("Unsupported type ".concat(type, " (in ").concat(idSegments.join("."), ")"));
        }
    }
  };

  process(data, {
    skipIndent: skipFirstIndent
  });
  return React.createElement("div", {
    className: "rjd-container",
    style: _objectSpread(_objectSpread({
      padding: "1rem 2rem",
      paddingTop: sections[0].header ? "1rem" : "2rem",
      whiteSpace: "pre"
    }, theme.plain), extraTheme.container)
  }, data.description && React.createElement("div", {
    style: {
      marginBottom: "2rem"
    }
  }, React.createElement(JsonSchemaAnnotation, {
    style: extraTheme.head
  }, descriptionRenderer.render(data.description))), sections.map(function (_ref4, index) {
    var id = _ref4.id,
        header = _ref4.header,
        lines = _ref4.lines;
    var sectionIndent = Math.min.apply(Math, _toConsumableArray(lines.filter(function (line) {
      return line.tokens.length > 0;
    }).map(function (line) {
      return line.indent;
    })));
    var sectionRender = lines.map(function (_ref5, lineIndex) {
      var indent = _ref5.indent,
          tokens = _ref5.tokens;
      return React.createElement("div", {
        key: lineIndex,
        style: _objectSpread({
          marginLeft: (indent - sectionIndent) * indentSize,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden"
        }, extraTheme.section)
      }, tokens);
    });

    if (header) {
      sectionRender = React.createElement("div", {
        style: _objectSpread({
          position: "relative",
          margin: "1rem -1rem",
          padding: "1rem"
        }, id === activeId ? extraTheme.activeHeader : extraTheme.inactiveHeader)
      }, React.createElement("h3", {
        id: id !== null && id !== void 0 ? id : undefined,
        style: _objectSpread({
          position: "absolute",
          display: "block",
          marginTop: "-2rem",
          width: "100%",
          fontSize: 0,
          userSelect: "none"
        }, extraTheme.anchor),
        children: id
      }), header, sectionRender);
    }

    return React.createElement("div", {
      key: index,
      style: {
        marginTop: "-1rem",
        marginLeft: sectionIndent * indentSize
      }
    }, sectionRender);
  }));
}

export { JsonDoc };